import { MRT_ColumnDef } from 'mantine-react-table';
import { Group, Select, Text } from '@mantine/core';
import type { CSSProperties } from 'react';
import { formatDateTimeToShow } from 'app/utils/util-functions';
import { entitiesDocumentType, dealsFacilitiesDocumentType, } from 'app/models/dropdown-options'
import { ContractType } from 'app/models/common-types';
import IonIcon from '@reacticons/ionicons';

const getTextStyle = (color: string, fontSize = '14px'): CSSProperties => ({
    fontFamily: 'Plus Jakarta Sans',
    fontSize,
    fontWeight: 400,
    lineHeight: '32px',
    textAlign: 'left',
    color,


});

function TableHead({ header }: { header: string }) {
    return (
        <Text style={getTextStyle('#784595', '15px')}>
            {header}
        </Text>
    );
}
export type ColumnDefAttachmentsType = {
    attachments: string;
    id: string
    tags: string;
    documentType: string;
    documentTypeText?: string;
    contractType: string;
    uploadDate: string;
    uploader: string;
    onDelete: (row: any) => void
    onDownload: (row: any) => void
    handleDocumentTypeChange: (id: string, newValue: string) => void
}

export const columnDefsAttachments: MRT_ColumnDef<ColumnDefAttachmentsType>[] = [
    {
        id: 'attachments',
        size: 120,
        accessorKey: 'attachments',
        header: 'attachments',
        Header: <TableHead header={'Attachments'} />,
        Cell: ({ cell }) => {
            return (
                <Text style={{ ...getTextStyle('#476DB9') }}>
                    {cell.getValue<string>() ?? ''}
                </Text>

            );
        },
    },
    {
        id: 'documentType',
        accessorKey: 'documentType',
        size: 100,
        header: 'Document Type',
        Header: <TableHead header={'Document Type'} />,
        Cell: ({ row }) => {
            const selectData = row.original.contractType === ContractType.Entities ? entitiesDocumentType : dealsFacilitiesDocumentType;

            // Create display value: "Other(CustomType)" if documentType is "Other" and documentTypeText exists
            const displayValue = row.original.documentType === 'Other' && row.original.documentTypeText
                ? `Other (${row.original.documentTypeText})`
                : row.original.documentType;

            // Replace "Other" with formatted "Other(CustomType)" if needed
            const dataWithCustom = row.original.documentType === 'Other' && row.original.documentTypeText
                ? selectData.map(item => item.value === 'Other' ? { ...item, label: displayValue, value: displayValue } : item)
                : selectData;

            return (
                <div onClick={(e) => e.stopPropagation()}>
                    <Select
                        withinPortal
                        sx={{
                            input: {
                                border: 0,
                                color: '#476DB9',
                                background: 'none',
                                paddingLeft: 0,
                            }
                        }}
                        data={dataWithCustom}
                        placeholder="Type"
                        value={displayValue}
                        onChange={(e) => {
                            row.original.handleDocumentTypeChange(row.original.id, e ?? '')
                        }}
                        rightSection={<IonIcon size="large" name="chevron-down-outline" style={{ color: '#b8b8b8' }} />}
                    />
                </div>
            );
        },
    },
    {
        size: 100,
        accessorKey: 'uploadDate',
        header: 'uploadDate',
        Header: <TableHead header={'Upload Date'} />,
        Cell: ({ cell }) => {
            const attachmentDate = formatDateTimeToShow(new Date(cell.getValue<string>() ?? ''))
            return (
                <Text style={{ ...getTextStyle('#476DB9') }}>
                    {attachmentDate}
                </Text>
            );
        },
    },

    {
        size: 50,
        accessorKey: 'uploader',
        header: 'uploader',
        Header: <TableHead header={'Uploader'} />,
        Cell: ({ cell }) => {
            return (
                <Text style={{ ...getTextStyle('#476DB9') }}>
                    {cell.getValue<string>() ?? ''}
                </Text>
            );
        },
    },

    {
        accessorKey: 'id',
        id: 'delete',
        size: 50,
        header: '',
        Header: () => (<TableHead header={''} />
        ),
        Cell: ({ row }) => {
            return (<Group position="apart" pr="10px">
                <Text
                    style={{ ...getTextStyle('#476DB9'), cursor: 'pointer' }}
                    onClick={() =>
                        row.original.onDownload(row.original)
                    }
                >
                    Download
                </Text>
                <Text
                    style={{ ...getTextStyle('#EE5959'), cursor: 'pointer' }}
                    onClick={() =>
                        row.original.onDelete(row.original)
                    }                >
                    Delete
                </Text>
            </Group >
            )

        },
    }
];
